export const defaultStyle = {
    container: "container test",
    imgWrpr: "h-min overflow-hidden rounded-[2rem] px-auto text-sm tracking-wide text-darkBlue font-medium before:pr-5 w-[195px] grid",
    heading: "text-xl text-white text-center",
    description: "text-xl text-white px-auto text-center",
    linkWrpr: "",
    btnStyle: "hidden",
    contentWrpr: "relative",
    img: "rounded-[2rem]",
    cardsSliderWrapr: "",
    cardWrapr: "cardWrapr text-white  text-[40px] px-auto w-full text-center pt-50 font-bold",
    cardDesc: "cardDesc text-white  text-[18px] px-auto lg:w-1/3 mx-auto w-full text-center pb-40",
    cardWrpr: "lg:w-[1170px] mx-auto max-w-full",
    linkCardsWrpr:"linkCardsWrpr",
    cardsContainer:"cardsContainer"
}

export const FIVE_COLUMN_CARDS_LAYOUT = {
    container: "bg-darkBlue text-white py-50 lg:pt-[44px] lg:pb-40 phillyfivecards lg:relative ",
    cardsContainer: "grid lg:grid-cols-5 bg-darkBlue carousel-item active md:w-auto lg:w-[1170px] mx-auto py-25",
    cardWrpr: "lg:max-w-full lg:w-[1170px] mx-auto mt-30 mb-0 lg:mb-15 lg:pl-0 lg:ml-auto caroselScrnSize lg:max-h-[227px]",
    cardsWrapr: "grid lg:grid-cols-5 bg-darkBlue carousel-item active lg:w-[1170px] mx-auto py-20 ",
    imgWrpr: "h-min overflow-hidden rounded-[2rem] px-auto text-sm tracking-wide text-darkBlue font-medium before:pr-5 w-[195px] lg:w-[180px] grid ",
    heading: "text-[40px] text-white text-center w-full lg:w-3/4 font-Light lg:mx-auto px-15 [&>h2]:leading-[49px] tracking-wide:leading-[50px]",
    description: "philyFiveCrd text-[18px] md:w-[455px] flex w-full  text-white px-auto mx-auto pb-20 text-center justify-center leading-30 px-10 tracking-[0]",
    linkWrpr: "lg:mt-0 lg:mr-0 lg:mx-auto mb-20 flex justify-center lg:px-5 px-[12px] md:min-w-[180px]",
    contentWrpr: "relative",
    img: "rounded-[2rem]",
    btnWrpr: "",
    imageCardStyle: {
        imgWrpr: "h-min overflow-hidden rounded-[30px]  px-auto text-sm tracking-wide philyImg text-darkBlue font-medium before:pr-5 w-[195px] grid lg:w-[180px]",
        contentWrpr: "relative",
        heading: "text-xl absolute flex text-white font-Bold px-auto  bottom-[60px] w-full justify-center z-[1]",
        description: "text-white absolute text-[15px] px-auto lg:w-auto md:w-[195px] bottom-[40px] text-center  flex justify-center z-[1] leading-[20px]",
        gradTop: "absolute bottom-[0px]  w-[195px] rounded-b-[2rem] h-[140px] bg-toTopGradient max-w-full",
        contentWrapr: "contentWrapr flex justify-center w-full",
        imageBoxWrpr: "imageBoxWrpr min-h-[180px]  md:min-w-[180px] min-w-[160px]",
    },
}

export const IMAGE_TEXT_COLUMN_LAYOUT = {
    cardsContainer: "bg-white  md:w-[1170px] mx-auto py-20 grid lg:grid-cols-4 bg-white",
    container: "bg-white abtPhildlpi lg:w-[1170px] lg:mx-auto py-20  cookingSteps max-w-full md:mx-25",
    imgWrpr: "imgWrpr",
    heading: " heading lg:mx-auto font-Light flex justify-center text-[40px] text-center md:w-[75%] md:mx-auto w-[90%] mx-15 leading-[49px] pb-20",
    description: "description 1 text-[30px] mb-30 lg:mb-0 text-center mx-auto lg:w-3/5 w-full leading-[40px]",
    linkWrpr: "linkWrpr px-15 mb-40",
    contentWrpr: "contentWrpr",
    img: "img",
    cardWrpr: "lg:w-[1170px] mx-auto max-w-full",
}

/*check /Procurement/Vendor-Cyber-Risk-Management for UI */
export const FOUR_IMG_TEXT_LAYOUT = {
    cardsContainer: "bg-white mx-auto pb-20 grid md:grid-cols-4 md:gap-[10px] lg:gap-[30px] bg-white",
    container: "md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[15px]",
    imgWrpr: "imgWrpr",
    heading:
        " heading lg:mx-auto font-Bold text-[30px] lg:text-[40px] text-center mx-10 leading-[37px] lg:leading-[49px] md:child:block child:pr-10 lg:child:pr-0 tracking-normal",
    description:
        "description 2 lg:text-[30px] text-[23px] mb-30 text-center mx-auto lg:w-[54%] md:w-[80%] w-full lg:leading-[40px] leading-[30px] tracking-normal px-10 md:px-0",
    linkWrpr: "linkWrpr px-15 mb-40",
    contentWrpr: "contentWrpr",
    img: "img",
    cardWrpr: "lg:max-w-full lg:w-[1170px] lg:px-20 mx-auto fourImageTextLayout",
    linkCardsWrpr: 'linkCardsWrpr h-full first:bg-darkGreen bg-aquaSpring'
}

export const FOUR_CARD_IMAGE_TEXT_LAYOUT = {
    mainContainer: "bg-grayWhite",
    cardsContainer: " mx-auto grid md:grid-cols-4 md:gap-[10px] md:gap-[30px] px-[20px] md:px-[0px]",
    container: " md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[15px]",
    imgWrpr: "imgWrpr",
    heading:
        " heading lg:mx-auto font-Light lg:text-[48px] text-[24px] font-light leading-[36px] lg:tracking-normal text-green md:mb-[45px] mb-[30px]  text-left md:child:block child:pr-10 lg:child:pr-0",
    description:
        "description 2 lg:text-[30px] text-[23px] mb-30 text-center mx-auto lg:w-[54%] md:w-[80%] w-full lg:leading-[40px] leading-[30px] tracking-normal px-10 md:px-0",
    linkWrpr: "linkWrpr px-15 mb-40",
    contentWrpr: "contentWrpr",
    img: "img",
    cardWrpr: "lg:max-w-full lg:w-[1170px] lg:px-20 mx-auto fourImageTextLayout",
    linkCardsWrpr: 'linkCardsWrpr h-full lg:my-[45px] '
}

export const BLUE_TWO_COLUMN_LAYOUT = {
    cardsWrapr: "lg:grid justify-center lg:gap-30 md:gap-12 gap-18 lg:grid-cols-2 carousel-item active lg:w-[1170px] md:w-3/4  mx-auto py-30 lg:px-15 rangeCardWrpr lg:mb-100 max-w-full",
    heading: "px-29 text-3xl font-Bold py-[49px] leading-[34.5px] text-white bg-darkBlue text-center tracking-[1px]",
    linkWrpr: "lg:mt-0 lg:mr-0 mb-30px lg:ml-0 lg:w-[555px] lg:h-[555px] w-full md:h-[600px] mb-20px bg-[#00339f] rounded-[20px] flex mx-[7px] bluLinkWrpr",
    cardWrpr: "lg:w-[1170px] mx-auto",
    linkCardsWrpr: "linkCardsWrpr flex justify-center w-full lg:mb-0 md:mb-30 mb-30",
}

export const FOUR_CARD_IMAGE = {
    mainContainer: "bg-White",
    cardsContainer: " mx-auto grid md:grid-cols-4 md:gap-[10px] md:gap-[30px] px-[20px] md:px-[0px]",
    container: " md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[15px]",
    imgWrpr: "imgWrpr",
    heading:
        " heading lg:mx-auto font-Light lg:text-[48px] text-[24px] font-light leading-[36px] lg:tracking-normal text-green md:mb-[45px] mb-[30px]  text-left md:child:block child:pr-10 lg:child:pr-0",
    description:
        "description 2 lg:text-[30px] text-[23px] mb-30 text-center mx-auto lg:w-[54%] md:w-[80%] w-full lg:leading-[40px] leading-[30px] tracking-normal px-10 md:px-0",
    linkWrpr: "linkWrpr px-15 mb-40",
    contentWrpr: "contentWrpr",
    img: "img",
    cardWrpr: "lg:max-w-full lg:w-[1170px] lg:px-20 mx-auto fourImageTextLayout",
    linkCardsWrpr: 'linkCardsWrpr h-full lg:my-[45px] '
}

export const THREE_COLUMN_IMAGE_CARDS_LAYOUT = {
    container: "py-20 md:py-50 my-0 mx-auto px-[35px] lg:px-[15px] md:max-w-md lg:max-w-lg xl:max-w-xl md:max-w-md THREE_COLUMN_IMAGE_CARDS_LAYOUT print-noshow",
    cardsContainer: "flex flex-wrap pb-[50px] pb-[0px] lg:mx-[-54px]", //justify-center align-center mx-auto - commented because it was casing issue in United-States
    cardsWrapr: "lg:grid lg:grid-cols-3 py-15 justify-center items-center mx-auto  mb-30",
    imgWrpr: "w-full",
    heading: "capitalize text-left font-Light text-[24px] md:text-[48px] text-green mb-[20px] md:leading-[72px]",
    description: "text-[21px] font-Regular tracking-[0.53px] text-black leading-[31.5px]",
    linkCardsWrpr: "CardPackag lg:w-[33.33%] w-full my-25 pl-0 lg:px-[54px]", //lg:my-[100px]
    linkWrpr: "",
    btnWrpr: "buttonEffect2",
    contentWrpr: "5",
    img: "6",
    sliderMob: "md:mb-0 mb-30",
    cardWrpr: " mx-auto rangeSubpage",
}
export const recipePageSlider = {
    container: "bg-darkBlue text-white py-50 recipePagecards",
    cardsContainer: "grid lg:grid-cols-5 bg-darkBlue carousel-item active lg:w-[1170px] mx-auto py-25",
    cardsWrapr: "grid lg:grid-cols-5 bg-darkBlue carousel-item active lg:w-[1170px] mx-auto py-20 ",
    imgWrpr: "h-min overflow-hidden rounded-[2rem] px-auto text-sm tracking-wide text-darkBlue font-medium before:pr-5 w-[195px] lg:w-[180px] grid ",
    heading: "text-[40px] text-white text-center mb-8",
    description: "text-3xl flex w-full text-white px-auto mx-auto pb-20 text-center justify-center leading-30 px-10",
    linkWrpr: "lg:mt-0 mr-0 mx-auto mb-20 flex justify-center",
    contentWrpr: "relative",
    img: "rounded-[2rem]",
    cardWrpr: "lg:w-[1170px] mx-auto ",
}

export const BOTTOM_RECEPE_CARDS = {
    container: " lg:w-[1170px] w-auto overflow-hidden mx-auto py-20 mt-40 max-w-full",
    heading: "receipeHeading text-[30px] mb-[20px] text-darkBlue flex w-full lg:mx-auto x-15 justify-center text-center",
    gradientTop: "reciepeGradient absolute bottom-[0px] left-[0px] lg:mb-[20px] lg:mb-0 w-full rounded-b-[2rem] h-[140px] bg-toTopGradient",
    liWrpr: "relative",
    imgCardWrpr: "relative",
    cardsContainer: "cardsContainer lg:grid lg:grid-cols-3 grid-cols-6 lg:gap-25 lg:w-[1170px] mx-auto px-15 lg:px-30 ",
    linkWrpr: "linkWrpr relative",
    linkCardsWrpr: " linkCardsWrpr overflow-hidden rounded-20",
    sliderMob: "sliderMob",
    cardWrpr: "lg:w-[1170px] mx-auto",
}
export const Similar_Recipe_variant = {
    container: "pt-50 my-0 mx-auto overflow-hidden lg:max-w-full lg:w-[1170px] ClsRecipeCards",
    cardsContainer: "lg:grid lg:grid-cols-4 py-15 justify-center align-center mx-auto lg:w-[1140px] mb-30",
    cardsWrapr: "p-15 flex justify-center flex-wrap mx-auto lg:text-center",
    imgWrpr: "",
    heading: "",
    description: "text-[30px] font-Bold mx-0 mt-px ml-[16px] lg:text-left text-center",
    linkCardsWrpr: " linkCardsWrpr overflow-hidden   md:left-[0px] relative left-[-65px] lg:left-[0] rounded-[20px]",
    linkWrpr: "",
    btnWrpr: "buttonEffect2",
    contentWrpr: "",
    img: "",
    sliderMob: "sliderMob mb-30",
    cardWrpr: "lg:w-[1170px] mx-auto max-w-full",
    gradientTop: "reciepeGradient absolute bottom-[0px] left-[0px] lg:mb-[20px] lg:mb-0 w-full rounded-b-[2rem] h-[140px] bg-toTopGradient",
}

export const TWO_COLUMN_IMAGE_CARDS = {
    container: "twoColSection my-0 mx-auto md:max-w-md lg:max-w-lg xl:max-w-xl px-35 lg:px-15 my-[30px] lg:my-[50px]",
    cardsContainer: "lg:grid grid-cols-2 lg:mx-[-70px]", //my-[50px]
    cardsWrapr: "cardsWrapr p-15 grid grid-col-2",
    imgWrpr: "",
    heading: "heading text-green text-[24px] md:text-[24px] lg:text-[48px] font-Light [&>p]:font-Light font-[300] leading-[1.2] mb-[35px]",
    description: "text-[14px] md:text-[30px] lg:text-[21px] text-black normal-case mb-0 mt-0 box-border font-Regular tracking-[0.35px] md:tracking-[0.75px] lg:tracking-[0.53] leading-[20px] md:leading-[40px] lg:leading-[31.5px] text-left",
    linkCardsWrpr: "linkCardsWrpr relative lg:px-[70px] my-[25px] [&>div>div>p]:mb-[35px] [&>div>div>p]:pointer-events-auto [&>div>p]:pointer-events-auto [&>div>div>p>a]:pointer-events-auto [&>div>p>a]:pointer-events-auto [&>div>div>p>a:hover]:underline [&>div>div>p>a]:text-[21px] [&>div>div>p>a]:font-bold [&>div>div>p>a]:leading-[31px] [&>div>div>p>a]:text-purple [&>div>div>p>a:hover]:text-orange [&>div>div>p>a]:max-md:text-[14px] [&>div>div>p>a]:max-md:leading-[21px] [&>div>p]:mb-[35px] [&>div>p]:pointer-events-auto [&>div>p>a]:pointer-events-auto [&>div>p>a:hover]:underline [&>div>p>a]:text-[21px] [&>div>p>a]:font-bold [&>div>p>a]:leading-[31px] [&>div>p>a]:text-purple [&>div>p>a:hover]:text-[#CB4E0B] [&>div>p>a]:max-md:text-[14px] [&>div>p>a]:max-md:leading-[21px]",
    linkWrpr: "",
    btnWrpr: "buttonEffect2",
    contentWrpr: "",
    img: "",
    sliderMob: "sliderMob mb-30",
    cardWrpr: "lg:w-[1170px] mx-auto max-w-full",
    gradientTop: "reciepeGradient absolute bottom-[0px] left-[0px] lg:mb-[20px] lg:mb-0 w-full rounded-b-[2rem] h-[140px] bg-toTopGradient",
    descriptionOutsideLinkTag:'descriptionOutsideLinkTag mt-[20px]',
}
export const TWO_COLUMN_IMAGE_CARDS_PURPLE_HEADING = {
    ...TWO_COLUMN_IMAGE_CARDS,
    heading: "headingPurple text-[36px] md:text-[60px] font-MDLZBiteType tracking-[1.2px] leading-[43.2px] text-purple mb-[25px] mx-auto max-md:px-[15px] py-[40px] text-center md:text-left",
}
export const JOB_DETAIL_TWO_COLUMN_IMAGE_CARDS = {
    ...TWO_COLUMN_IMAGE_CARDS
}

export const RECIPE_CARDS_SLIDER = {
    container: "py-50 my-0 mx-auto  lg:max-w-full lg:w-[1170px] bg-darkBlue text-white",
    cardsContainer: "lg:grid lg:grid-cols-3 py-15 justify-center align-center mx-auto lg:w-[1140px] mb-30",
    cardsWrapr: "lg:grid lg:grid-cols-3 py-15 justify-center ",
    imgWrpr: "2",
    heading: "3",
    description: "text-3xl text-center mx-0 mb-40 mt-px",
    linkCardsWrpr: "lg:w-[354px] lg:h-[354px] lg:flex lg:justify-center lg:flex-wrap",
    linkWrpr: "",
    btnWrpr: "buttonEffect2",
    contentWrpr: "5",
    img: "6",
    sliderMob: "mb-30",
    cardWrpr: "lg:w-[1170px] mx-auto",
}

export const FORM_SUBMIT_CARDS = {
    container: "bg-darkBlue lg:w-[945px] md:w-[440px] rounded-20 bg-white md:mx-auto p-25 mx-10",
    cardsContainer: "",
    cardWrpr: "",
    cardsWrapr: "",
    imgWrpr: "",
    heading: "text-[40px] mt-5 text-center w-full font-Bold lg:mx-auto md:px-15 tracking-wide leading-[49px] ",
    description: "text-[25px] flex w-full px-auto mx-auto text-center justify-center leading-30 lg:px-10 md:px-0 tracking-[0] mt-15 mb-20 lg:w-[750px] text-[#7f7f7f] formSubmitCard",
    linkWrpr: "",
    contentWrpr: "",
    img: "",
    btnWrpr: " before:bg-downloadIcon before:bg-no-repeat before:bg-left-top before:bg-[length:100%_100%] before:inline-block before:mr-10 before:relative before:top-6 before:w-24 before:h-24",
    btnContainer: "  buttonEffect2 downloadBtn"
}

export const PACKAGING_PLASTICS_IMAGE_C_LAYOUT = {
    container: "py-50 my-0 mx-auto  px-[35px] px-[35px] md:px-[15px] lg:max-w-lg xl:max-w-xl md:max-w-md THREE_COLUMN_IMAGE_CARDS_LAYOUT print-noshow",
    cardsContainer: "flex flex-wrap py-[50px]  pb-[0px] justify-center align-center mx-auto  mx-[-15px]",
    cardsWrapr: "lg:grid lg:grid-cols-3 py-15 justify-center items-center mx-auto  mb-30",
    imgWrpr: "w-full",
    heading: "max-w-xl mx-auto capitalize text-left font-Light text-[24px] md:text-[48px] text-green mb-[35px] md:leading-[72px]",
    description: "text-[21px] font-Regular tracking-[0.53px] text-black leading-[31.5px]",
    linkCardsWrpr: "CardPackag lg:w-[33.33%] w-full my-[50px] px-[15px]",
    linkWrpr: "",
    btnWrpr: "buttonEffect2",
    contentWrpr: "5",
    img: "6",
    sliderMob: "md:mb-0 mb-30",
    cardWrpr: " mx-auto rangeSubpage",
}
export const TABCONTENT_IMAGECARDLAYOUT = {
    container: "threeColSection my-0 mx-auto md:max-w-md lg:max-w-lg xl:max-w-xl px-35 md:px-15 my-[30px] lg:my-[50px]",
    cardsContainer: "lg:grid grid-cols-2 ", //my-[50px]
    cardsWrapr: "cardsWrapr p-15 grid grid-col-2",
    imgWrpr: "",
    heading: "heading text-green text-[24px] lg:text-[48px] font-Light [&>p]:font-Light font-[300] leading-[1.2] mb-[35px]",
    description: "text-[14px] md:text-[30px] font-Regular tracking-[0.35px] md:tracking-[0.75px] leading-[20px] md:leading-[40px] text-left",
    linkCardsWrpr: "linkCardsWrpr relative lg:[&:nth-child(odd)]:pr-[40px] lg:[&:nth-child(even)]:pl-[40px] pt-50 md:py-[50px]",
    linkWrpr: "",
    btnWrpr: "buttonEffect2",
    contentWrpr: "",
    img: "",
    sliderMob: "sliderMob mb-30",
    cardWrpr: "lg:w-[1170px] mx-auto max-w-full",
    gradientTop: "reciepeGradient absolute bottom-[0px] left-[0px] lg:mb-[20px] lg:mb-0 w-full rounded-b-[2rem] h-[140px] bg-toTopGradient",
}
export const IMAGES_INLINE = {
    ...defaultStyle,
    container: "container xl:max-w-xl lg:max-w-lg md:max-w-md px-[15px] mx-auto w-full py-[30px] lg:py-[50px]",
    cardsContainer: "cardsContainer flex flex-wrap lg:flex-nowrap justify-around items-center w-[100%] ",
    cardWrpr: "mx-auto max-w-full",
}
export const THREE_COLUMN_IMAGE_CARDS_LAYOUT_WITH_BG = {
    ...THREE_COLUMN_IMAGE_CARDS_LAYOUT,
    mainContainer: "bg-grayWhite",
    heading: "text-purple font-MDLZBiteType mb-[60px] md:mb-[80px] md:leading-[72px] leading-[43.2px]  tracking-normal text-[36px] md:text-[60px] md:px-[15px] px-[35px]",
    linkCardsWrpr: "CardPackag lg:w-[33.33%] w-full my-0 my-20 pl-0 lg:px-[25px]",
}
export const FLAG_IMAGES_INLINE = {
    ...IMAGES_INLINE,
    container: "container xl:max-w-xl lg:max-w-lg md:max-w-md px-[35px] lg:px-[15px] mx-auto w-full py-[30px] lg:py-[50px]",
    heading: "text-left font-Light text-[24px] md:text-[48px] text-green mb-[20px] md:leading-[72px]",
    description: "text-[14px] md:text-[21px] font-Regular tracking-[0.53px] leading-[21px] md:leading-[31.5px] text-left pb-[25px] md:pb-[35px]",
    cardsContainer: "cardsContainer flex flex-wrap lg:flex-nowrap justify-start items-center w-[100%] ",
}

export const TWO_COLUMN_IMAGE_CARDS_WITHOUT_SPACE = {
    container: "twoColSection my-0 mx-auto md:max-w-md lg:max-w-lg xl:max-w-xl px-35 lg:px-15",
    cardsContainer: "lg:grid grid-cols-2 lg:mx-[-70px]", //my-[50px]
    cardsWrapr: "cardsWrapr p-15 grid grid-col-2",
    imgWrpr: "",
    heading: "headingPurple text-[36px] md:text-[60px] font-MDLZBiteType tracking-[1.2px] leading-[43.2px] text-purple mb-[25px] mx-auto max-md:px-[15px] pb-[40px] text-center md:text-left",
    description: "text-[14px] md:text-[30px] lg:text-[21px] text-black normal-case mb-0 mt-0 box-border font-Regular tracking-[0.35px] md:tracking-[0.75px] lg:tracking-[0.53] leading-[20px] md:leading-[40px] lg:leading-[31.5px] text-left",
    linkCardsWrpr: "linkCardsWrpr relative lg:px-[70px] my-[25px] [&>div>div>p]:mb-[35px] [&>div>div>p]:pointer-events-auto [&>div>p]:pointer-events-auto [&>div>div>p>a]:pointer-events-auto [&>div>p>a]:pointer-events-auto [&>div>div>p>a:hover]:underline [&>div>div>p>a]:text-[21px] [&>div>div>p>a]:font-bold [&>div>div>p>a]:leading-[31px] [&>div>div>p>a]:text-purple [&>div>div>p>a:hover]:text-orange [&>div>div>p>a]:max-md:text-[14px] [&>div>div>p>a]:max-md:leading-[21px] [&>div>p]:mb-[35px] [&>div>p]:pointer-events-auto [&>div>p>a]:pointer-events-auto [&>div>p>a:hover]:underline [&>div>p>a]:text-[21px] [&>div>p>a]:font-bold [&>div>p>a]:leading-[31px] [&>div>p>a]:text-purple [&>div>p>a:hover]:text-[#CB4E0B] [&>div>p>a]:max-md:text-[14px] [&>div>p>a]:max-md:leading-[21px]",
    linkWrpr: "",
    btnWrpr: "buttonEffect2",
    contentWrpr: "",
    img: "",
    sliderMob: "sliderMob mb-30",
    cardWrpr: "lg:w-[1170px] mx-auto max-w-full",
    gradientTop: "reciepeGradient absolute bottom-[0px] left-[0px] lg:mb-[20px] lg:mb-0 w-full rounded-b-[2rem] h-[140px] bg-toTopGradient",
    descriptionOutsideLinkTag:'descriptionOutsideLinkTag mt-[20px]',
}

export const COCOA_PROGRAM_DESKTOP_SLIDER = {
    mainContainer: "sixty-years bg-[#36174D] relative hidden min-[991px]:block",
    container: "pb-[125px] xl:max-w-[1196px] mx-auto px-20 xl:px-0",
    heading: "",
    description: "",
    cardsContainer: "",
    linkCardsWrpr: "",
    imgWrpr: "",
}

export const COCOA_PROGRAM_MOBILE_SLIDER = {
    mainContainer: "sixty-years bg-[#36174D] relative block min-[991px]:hidden",
    container: "pb-[140px] lg:pb-[145px] xl:max-w-[1196px] mx-auto px-20 xl:px-0",
    heading: "",
    description: "",
    cardsContainer: "",
    linkCardsWrpr: "",
    imgWrpr: "",
}

export const ABOUT_US_FOUR_CARD = {
    container: "lg:max-w-lg xl:max-w-[1196px] pb-[40px] mx-auto px-20 xl:px-0 relative",
    heading: "text-[#AD8246] font-MDLZBiteType text-[48px] leading-[57.6px] text-center mb-32",
    description: "font-BwSurco text-[20px] leading-[24px] tracking-normal text-black text-left lg:text-center mb-[48px]",
    cardsContainer: "lg:max-w-lg xl:max-w-[1196px] mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 justify-between gap-[48px]",
    linkCardsWrpr: "w-full",
    imgWrpr: "",
}

export const ABOUT_US_THREE_CARD = {
    container: "about-us-three-card lg:max-w-lg xl:max-w-[1196px] mx-auto py-[60px] px-20 xl:px-0 relative",
    heading: "text-[#AD8246] font-MDLZBiteType text-[48px] leading-[57.6px] text-center mb-32",
    description: "font-BwSurco text-[20px] leading-[24px] text-black text-left lg:text-center mb-[48px]",
    cardsContainer: "about-three-card lg:max-w-lg xl:max-w-[1196px] mx-auto grid grid-cols-1 lg:grid-cols-3 justify-between gap-[48px] lg:gap-[40px]",
    linkCardsWrpr: "w-full",
    imgWrpr: "imgWrpr",
    imageWrapperMedium: "brandspeak imageWrapperMedium absolute z-10 right-0 md:right-0 xl:right-[-80px] top-[-94px] lg:bottom-auto w-auto md:w-[22%] xl:w-auto",
    imageWrapperLarge: "brandspeak imageWrapperLarge absolute z-10 right-0 lg:right-[-80px] top-[-130px] lg:bottom-auto",
}

export const COCOA_RIGHT_SLIDER = {
    mainContainer: "relative",
    container: "coca-slider-section pt-[100px] lg:pt-[60px] pb-[120px] lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 lg:px-0",
    heading: "font-MDLZBiteType text-[60px] leading-[72px] lg:text-[72px] lg:leading-[86.4px] text-purple text-center mb-[32px] xl:mb-[32px]",
    description: "font-BwSurco text-[20px] leading-[24px] text-black text-left tracking-normal pb-40 [&>p>strong]:block [&>p>strong]:text-[26px] [&>p>strong]:leading-[31.2px] [&>p>strong]:mb-[40px] [&>p>strong]:text-center",
    cardsContainer: "",
    linkCardsWrpr: "",
    imgWrpr: "",
    imageWrapperMedium: "brandspeak imageWrapperMedium absolute z-10 right-[0px] lg:top-[-160px] hidden lg:block w-[14%]",
    imageWrapperLarge: "brandspeak imageWrapperLarge absolute z-10 left-0 top-[-120px] lg:top-[-40px] w-[12%]",
}

export const CAROUSEL_SLIDER_BIGIMG_CARD = {
  ...COCOA_RIGHT_SLIDER,
  container: "coca-slider-section coco-slider-w-map pt-[100px] lg:pt-[60px] pb-[120px] lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 lg:px-0",
  imgContainer: "w-full lg:w-[38%]",
}

export const CAROUSEL_SLIDE = {
    mainContainer: "bg-[#D4B7EC] bu-slider-sec relative",
    container: "pt-[40px] pb-[145px] xl:max-w-[1196px] mx-auto px-20 xl:px-0",
    heading: "font-MDLZBiteType text-[60px] leading-[72px] text-DarkPurple text-center mb-[32px] xl:mb-[32px]",
    description: "font-BwSurco text-[20px] leading-[24px] text-black text-left tracking-normal pb-40 [&>p>strong]:block [&>p>strong]:text-[26px] [&>p>strong]:leading-[31.2px] [&>p>strong]:mb-[40px] [&>p>strong]:text-center",
    cardsContainer: "",
    linkCardsWrpr: "",
    imgWrpr: "",
    imageWrapperMedium: "brandspeak imageWrapperMedium absolute z-10 right-0 top-[140px] lg:bottom-auto hidden lg:block",
    imageWrapperLarge: "brandspeak imageWrapperLarge absolute z-10 right-0 top-[140px] lg:bottom-auto",
}
export const COMMUNITY_THREE_CARDS_LAYOUT = {
    mainContainer:"community_cards mainContainer bg-[#4F2170] ",
    container: "xl:max-w-[1196px] mx-auto pb-[80px]",
    linkCardsWrpr:"linkCardsWrpr basis-[33.33%]",
    cardsContainer:"flex flex-col lg:flex-row gap-x-[32px] gap-y-[48px] px-20 xl:px-0"
}

export const COMMUNITY_IMG_CARD = {
    mainContainer:"community_imgcard mainContainer relative",
    container:"mx-auto pt-[100px] lg:pt-[60px] pb-[40px]",
    imageWrapperMedium: "brandspeak imageWrapperMedium absolute z-10 left-0 right-0 mx-auto w-fit lg:left-30 lg:right-auto top-[-100px] lg:bottom-auto",
    imageWrapperLarge: "brandspeak imageWrapperLarge absolute z-10 right-0 top-[140px] lg:bottom-auto",
}

export const PILLARS_CARDS_WRAPPER = {
    mainContainer:"mainContainer bg-[#FAF3E7] pt-60 relative",
    container: "lg:max-w-lg xl:max-w-[1196px] mx-auto pb-[40px] px-20 lg:px-0",
    heading: "font-MDLZBiteType text-[60px] leading-[72px] text-DarkPurple text-center mb-32",
    description: "font-BwSurco text-[20px] leading-[24px] text-black text-left tracking-normal mb-40",
    linkCardsWrpr:"linkCardsWrpr basis-full lg:basis-[33.33%] mb-[32px] last:mb-0 lg:mb-0",
    cardsContainer:"flex gap-x-[32px] flex-col lg:flex-row",
    imageWrapperMedium: "",
    imageWrapperLarge: "brandspeak imageWrapperLarge absolute z-10 left-0 top-[-120px] top-[-75px] lg:top-[-85px]",
}
export const STORIES_OF_CHOICE_CARDS_SLIDER = {
    mainContainer: "relative z-10",
    container: "pb-100 my-0 bg-[#fdc583] storiesSliderSec text-black px-20",
    cardsContainer: "lg:grid lg:grid-cols-3 py-15 justify-center align-center mx-auto lg:w-[1140px] mb-30",
    cardsWrapr: "lg:grid lg:grid-cols-3 py-15 justify-center ",
    imgWrpr: "2",
    heading: "3",
    description: "text-3xl text-center mx-0 mb-40 mt-px",
    linkCardsWrpr: "lg:w-[354px] lg:flex lg:justify-center lg:flex-wrap",
    linkWrpr: "",
    btnWrpr: "buttonEffect2",
    contentWrpr: "5",
    img: "6",
    sliderMob: "mb-30",
    cardWrpr: "mx-auto lg:max-w-full lg:w-[1170px]",
}
export const MILESTONES_ACHIEVED_DESKTOP_SLIDER = {
    mainContainer: "milestone-achived desktop relative bg-[#562F23] mb-[492px] pb-[132px] hidden min-[991px]:block",
    container: "xl:max-w-[1196px] mx-auto px-20 xl:px-0",
    heading: "",
    description: "",
    cardsContainer: "",
    linkCardsWrpr: "",
    imgWrpr: "",
    imageWrapperMedium: "",
    imageWrapperLarge: "absolute z-10 left-[45px] top-auto bottom-[-25%]",
}

export const MILESTONES_ACHIEVED_MOBILE_SLIDER = {
    mainContainer: "milestone-achived mobile relative bg-[#562F23] mb-[316px] pb-[150px] block min-[991px]:hidden",
    container: "xl:max-w-[1196px] mx-auto px-20 xl:px-0",
    heading: "",
    description: "",
    cardsContainer: "",
    linkCardsWrpr: "",
    imgWrpr: "",
    imageWrapperMedium: "",
    imageWrapperLarge: "absolute z-10 left-[45px] top-auto bottom-[-25%]",
}